module.exports = __webpack_public_path__ + "static/media/Jarvis_logo.ff75c8e3.svg";